import firebase from "firebase/app";
import { writable } from "svelte/store";
import { app } from "../firebase";

export const currentUser = writable(null);

const auth = app.auth();
const db = app.firestore();

let authUser;
let currentUserSubscription;

const googleAuthProvider = new firebase.auth.GoogleAuthProvider();
const facebookAuthProvider = new firebase.auth.FacebookAuthProvider();

auth.onAuthStateChanged((user) => {
    authUser = user;
    if (!user) return currentUser.set(null);
    currentUser.set({ ...user, fromDb: false });
});

currentUser.subscribe((user) => {
    if (!user) return closeSubscription();
    if (user.fromDb) return;
    closeSubscription();
    subscribeToUser(user.uid);
});

function closeSubscription() {
    if (!currentUserSubscription) return;
    currentUserSubscription();
}

function subscribeToUser(uid) {
    currentUserSubscription = db
        .collection("users")
        .doc(uid)
        .onSnapshot((snapshot) => {
            const user = { ...snapshot.data(), uid };
            currentUser.set({
                ...authUser,
                ...user,
                fromDb: true,
                isAdmin: user.roles && user.roles.admin,
                isTrainer: user.roles && user.roles.trainer,
            });
        });
}

export function signIn(email, password) {
    return auth.signInWithEmailAndPassword(email, password);
}

export function signInWithGoogle() {
    return auth.signInWithPopup(googleAuthProvider);
}

export function signInWithFacebook() {
    return auth.signInWithPopup(facebookAuthProvider);
}

export function signOut() {
    currentUser.set(null);
    return auth.signOut();
}
